/**
 * Build a CSV string for one DCF — one row per answer.
 * @param {object} detail DCF detail payload
 * @returns {string}
 */
export const buildDcfCsvContent = detail => {
  const headers = [
    'dcf_id',
    'status',
    'action',
    'subject_id',
    'participant_id',
    'instrument_id',
    'instrument_name',
    'instrument_version',
    'instance_id',
    'start_by',
    'completed_by',
    'question_id',
    'question_number',
    'question_label',
    'original_answer',
    'corrected_answer',
    'original_answer_id',
    'answer_id',
  ]

  const escapeCell = value => {
    if (value == null) return ''
    let text = String(value)
    // Prevent spreadsheet formula injection when staff open the export in Excel/Sheets.
    if (/^[=+\-@\t\r]/.test(text)) text = `'${text}`
    if (/[",\n\r]/.test(text)) return `"${text.replace(/"/g, '""')}"`
    return text
  }

  const base = {
    dcf_id: detail?.id ?? '',
    status: detail?.status ?? '',
    action: detail?.action ?? '',
    subject_id: detail?.subject_id || detail?.participant_subject_id || '',
    participant_id: detail?.participant_id ?? '',
    instrument_id: detail?.instrument_id ?? '',
    instrument_name: detail?.instrument_name || detail?.instrument_title || '',
    instrument_version: detail?.instrument_version ?? '',
    instance_id: detail?.instance_id ?? '',
    start_by: detail?.start_by || detail?.started_by || '',
    completed_by: detail?.completed_by || '',
  }

  const answers = Array.isArray(detail?.answers) && detail.answers.length > 0
    ? detail.answers
    : [null]

  const lines = [headers.join(',')]
  answers.forEach(answer => {
    const row = headers.map(key => {
      if (Object.prototype.hasOwnProperty.call(base, key)) return escapeCell(base[key])
      if (!answer) return ''
      return escapeCell(answer[key])
    })
    lines.push(row.join(','))
  })

  return `${lines.join('\n')}\n`
}

export default { buildDcfCsvContent }
